export default function LoadingState({ label = "Loading" }) {
  return <div className="skeleton admin-skeleton" aria-label={label} />;
}